import { Link } from "react-router-dom";
import { Users, Package, Headphones, UserCircle, ArrowRight } from "lucide-react";

export default function UsersPage() {
  const userTypes = [
    {
      id: "collaborateurs",
      title: "Collaborateurs",
      description: "Gérer les collaborateurs des stores",
      icon: Users,
      path: "/admin/collaborateurs",
      gradient: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      iconColor: "text-blue-600",
      borderColor: "border-blue-200",
    },
    {
      id: "fournisseurs",
      title: "Fournisseurs",
      description: "Gérer les fournisseurs et leurs catégories",
      icon: Package,
      path: "/admin/fournisseurs",
      gradient: "from-green-500 to-green-600",
      bgColor: "bg-green-50",
      iconColor: "text-green-600",
      borderColor: "border-green-200",
    },
    {
      id: "supports",
      title: "Supports",
      description: "Gérer les utilisateurs support",
      icon: Headphones,
      path: "/admin/supports",
      gradient: "from-purple-500 to-purple-600",
      bgColor: "bg-purple-50",
      iconColor: "text-purple-600",
      borderColor: "border-purple-200",
    },
  ];

  return (
    <div className="p-4 md:p-6 min-h-screen bg-gray-50">
      {/* Header amélioré */}
      <div className="mb-6 md:mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="p-2 bg-primary/10 rounded-lg">
            <UserCircle className="w-6 h-6 md:w-7 md:h-7 text-primary" />
          </div>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
            Gestion des Utilisateurs
          </h1>
        </div>
        <p className="text-sm md:text-base text-gray-600 ml-12 md:ml-14">
          Sélectionnez le type d'utilisateur que vous souhaitez gérer
        </p>
      </div>
      
      {/* Grille centrée avec largeur maximale */}
      <div className="flex justify-center">
        <div className="w-full max-w-5xl">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {userTypes.map((type) => {
              const Icon = type.icon;
              return (
                <Link
                  key={type.id}
                  to={type.path}
                  className="group bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-6 md:p-8 flex flex-col items-center text-center border-2 border-gray-100 hover:border-gray-300 relative overflow-hidden"
                >
                  {/* Effet de fond au hover */}
                  <div className={`absolute inset-0 bg-gradient-to-br ${type.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}></div>
                  
                  {/* Contenu */}
                  <div className="relative z-10 w-full">
                    {/* Icône avec fond dégradé */}
                    <div className="mb-5 flex justify-center">
                      <div className={`relative p-4 rounded-2xl bg-gradient-to-br ${type.gradient} shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110`}>
                        <Icon className="w-8 h-8 md:w-10 md:h-10 text-white" />
                        <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 rounded-2xl transition-opacity duration-300"></div>
                      </div>
                    </div>
                    
                    {/* Titre */}
                    <h2 className="text-lg md:text-xl font-bold mb-2 text-gray-800 group-hover:text-gray-900 transition-colors">
                      {type.title}
                    </h2>
                    
                    {/* Description */}
                    <p className="text-sm md:text-base text-gray-600 mb-4 group-hover:text-gray-700 transition-colors">
                      {type.description}
                    </p>
                    
                    {/* Bouton d'action */}
                    <div className="flex items-center justify-center gap-2 text-sm font-medium text-gray-500 group-hover:text-primary transition-colors">
                      <span>Accéder</span>
                      <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                  
                  {/* Barre de couleur en bas */}
                  <div className={`absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r ${type.gradient} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left`}></div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

